const styles = () => ({
  root: {
    display: 'grid',
    gridTemplate: '"sidebar main" 1fr / auto 1fr',
    flex: '1 1 auto',
    height: '100%',
    minHeight: 0,
    minWidth: 0,
    overflow: 'hidden',
  },

  article: {
    display: 'flex',
    gridArea: 'main',
    overflow: 'auto',
  },

  dialogWidth: {
    maxWidth: 848,
  },
});

export default styles;
